function buildUnion(types) {
  return types.filter(Boolean).join(" | ") || "never";
}
export {
  buildUnion
};
//# sourceMappingURL=buildUnion.js.map
